var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompletedStep = function SvgCompletedStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.5,
    height: 32.5,
    x: 0.75,
    y: 0.75,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 4.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m23.665 12.832-8.577 8.577a.833.833 0 0 1-1.179 0l-3.577-3.577"
  })));
};
export default SvgCompletedStep;